/** README
 *  该模块管理项目中，所有【设备】的接口请求
 *  >>> eblock (能量块)
 *  >>> elink (能量链)
 *  >>> meter (电表)
 *  >>> unit (储能单元)
 * 
 *  注意：
 *      >>> 为方便维护，在业务中尽量通过index文件中提供的设备别名，应用各设备的接口
 *          >>> 如：调用eblock的相关接口，在业务中通过 eblockApi.xxxFn(url) 调用
 *      >>> 
 * 
 */

import { httpBus } from "@/api/index.js";
export * as eblockApi from "./eblock.js";
export * as elinkApi from "./elink.js";
export * as meterApi from "./meter.js";
export * as unitApi from "./unit.js";


/**
 * 获取充放电列表
 * @returns 
 */
export function getDevicesById(stationId) {
  return httpBus.request("get", `/device/v2/station/equipments/${stationId}`);
}
// 获取充放电列表 >>> new
export function getDevicesById2(stationId) {
  return httpBus.request(
    "get",
    `/device/v2/station/new/equipments/${stationId}`
  );
}


/** ====== [设备型号相关] ============================================================================================ */

/**
 * 查询设备型号基本信息列表
 * @param {*} query obj
 *    >>> pageNum: num
 *    >>> pageSize: num
 * @returns
 */
export function listModel(query) {
  return httpBus.request("get", `/device/model/list`, { params: query });
}

/**
 * 查询设备型号基本信息列表
 * @returns 
 */
export function getModel(modelId) {
  return httpBus.request("get", `/device/model/${modelId} `);
}

/**
 * 新增设备型号基本信息
 * @returns 
 */
export function addModel(data) {
  return httpBus.request("post", `/device/model/`, { data: data });
}


/**
 * 修改设备型号基本信息
 * @returns 
 */
export function updateModel(data) {
  return httpBus.request("put", `/device/model/`, { data: data });
}


/**
 * 删除设备型号基本信息
 * @returns 
 */
export function delModel(modelId) {
  return httpBus.request("delete", `/device/model/${modelId} `);
}


/**
 * 导出设备型号基本信息
 * @returns 
 */
export function exportModel(query) {
  return httpBus.request("get", `/device/model/export`, { params: query });
}














